import React, { Component } from 'react';
import FormContent from "../FormArea/FormContent"


class FastPathContainer extends Component {
    constructor(props) {
        super(props);
      }

    
    render() {
        let x=this.props.parentState;
        let localParentState={...x};
        let {formmodal}=this.props.component
        if(formmodal){
            localParentState.currentPage=formmodal.pagename 
        }else{
            localParentState.currentPage=this.props.component.pagename;
        }
        
        console.log("fastpath")
        console.log(localParentState)
        // localParentState.showButtons.submit=false;
        return (
            <div className="col-12">
                <FormContent
                    parentState={localParentState}
                    liftState={this.props.liftState}
                    liftGlobalState={this.props.liftGlobalState}
                    parentProps={this.props.parentProps}
                />
                
            </div>
        );
    }
}

export default FastPathContainer;